"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDetailSchema = exports.UserSchema = exports.PhoneNumberSchema = exports.EmailSchema = exports.NameSchema = void 0;
const zod_1 = require("zod");
const TokenMisc = __importStar(require("../misc/token"));
const LocationMisc = __importStar(require("../misc/location"));
const libphonenumber_js_1 = require("libphonenumber-js");
exports.NameSchema = zod_1.z.string();
exports.EmailSchema = zod_1.z.union([zod_1.z.string().email({ message: "Email invalid" }), zod_1.z.literal("")]);
exports.PhoneNumberSchema = zod_1.z.string().superRefine((val, ctx) => {
    try {
        const result = (0, libphonenumber_js_1.parsePhoneNumberWithError)(val);
        if (result.isValid()) {
            return true;
        }
        else {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: "Invalid phone number",
            });
        }
    }
    catch (error) {
        if (error instanceof libphonenumber_js_1.ParseError) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: error.message,
            });
        }
        else {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: "UNKNOWN",
            });
        }
    }
});
exports.UserSchema = zod_1.z.object({
    name: exports.NameSchema,
    email: exports.EmailSchema,
    phone: exports.PhoneNumberSchema
});
// User
exports.UserDetailSchema = zod_1.z.object({
    externalIds: TokenMisc.ExternalIdsSchema,
    role: zod_1.z.string().optional(),
    businessId: zod_1.z.string().optional(),
    is_angus_verified_producer: zod_1.z.boolean().optional(),
    name: zod_1.z.string().optional(),
    mobileNumber: exports.PhoneNumberSchema.optional(),
    emailAddress: exports.EmailSchema.optional(),
    agliveToken: zod_1.z.string().optional(),
    signature: zod_1.z.string().optional(),
    password: zod_1.z.string().optional(),
    device_id: zod_1.z.string().optional(),
    devices: LocationMisc.deviceDataSchema.optional(),
    notified: zod_1.z.array(zod_1.z.string())
});
